import { render, staticRenderFns } from "./UeberUnsPage.vue?vue&type=template&id=da5771b4&"
import script from "./UeberUnsPage.vue?vue&type=script&lang=js&"
export * from "./UeberUnsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports